// SPDX-License-Identifier: AGPL-3.0-or-later

import type {StreamActivity, StreamPlatform} from '@app/features/gateway/types/GatewayPresenceTypes';

const STREAM_PLATFORMS: ReadonlyArray<string> = ['twitch', 'kick'] satisfies Array<StreamPlatform>;

export function parseStreamActivity(raw: unknown): StreamActivity | null {
	if (typeof raw !== 'object' || raw === null) return null;
	const {platform, login, started_at} = raw as Record<string, unknown>;
	if (typeof platform !== 'string' || !STREAM_PLATFORMS.includes(platform)) return null;
	if (typeof login !== 'string' || typeof started_at !== 'number') return null;
	return {platform: platform as StreamPlatform, login, started_at};
}
